import React, { useState, useEffect } from 'react';
import { Form, Button, Row, Col, Alert } from 'react-bootstrap';
import { Link, useNavigate } from 'react-router-dom';
//import PhoneInput from 'react-phone-number-input';
import { FaEye, FaEyeSlash, FaUser } from 'react-icons/fa';
import useAuth from '../composant_reutilisable/useAuth';
import Navbar from '../composant_reutilisable/navbar';
import Sidebar from '../composant_reutilisable/sidebar';
//import 'react-phone-number-input/style.css';

import PhoneInput from "react-phone-input-2";
import 'react-phone-input-2/lib/style.css';

const ProfilUtilisateur = ({ titre }) => {
    useAuth(); // Vérifier l'authentification
    const navigate = useNavigate();
    const user_id = localStorage.getItem('userId');

    useEffect(() => {
        if (user_id) {
            document.title = "Transportpro | Profil";
        }
    }, [user_id]);

    const [userData, setUserData] = useState({
        email: '',
        nom: '',
        prenoms: '',
        tel: '',
        mdp: '',
        mdp1: '',
        mdp2: '',
    });

    const [initialUserData, setInitialUserData] = useState(userData);
    const [message, setMessage] = useState('');
    const [showMessage, setShowMessage] = useState(false);
    const [messageType, setMessageType] = useState('success'); // ou 'danger'

    const fetchUserData = async () => {
        const token = localStorage.getItem('access_token');

        try {
            const response = await fetch(process.env.REACT_APP_HOTE + `/recup-info-profil/${user_id}/`,
                {
                    method: 'GET',
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': `Bearer ${token}`
                    },
                });
            if (!response.ok) throw new Error('Erreur réseau');
            const data = await response.json();
            setUserData(data);
            setInitialUserData(data);
        } catch (error) {
            console.error('Erreur réseau:', error);
        }
    };
    useEffect(() => {
        fetchUserData();
    }, [user_id]);


    useEffect(() => {
        // Initialiser avec "22901" si le champ tel est vide
        if (userData.tel === "" && !initialUserData.tel) {
            setUserData(prev => ({ ...prev, tel: "22901" }));
        }
    }, []);

    const handleChange = (e) => {
        setUserData({
            ...userData,
            [e.target.name]: e.target.value
        });
    };


    const handlePhoneChange = (value, country) => {
        const numericValue = value.replace(/\D/g, '');

        if (country.dialCode === "229") {
            if (!numericValue.startsWith('22901') || numericValue.length < 5) {
                const userDigits = numericValue.replace(/^229/, '').replace(/^0?/, '').slice(0, 8);
                setUserData(prev => ({ ...prev, tel: '22901' + userDigits }));
                return;
            }

            const limitedValue = numericValue.slice(0, 13);
            setUserData(prev => ({ ...prev, tel: limitedValue }));
        } else {
            setUserData(prev => ({ ...prev, tel: numericValue }));
        }
    };


    const handleSubmit = async (e) => {
        e.preventDefault();
        const token = localStorage.getItem('access_token');
        try {
            const response = await fetch(process.env.REACT_APP_HOTE + `/modifier-profil-utilisateur/${user_id}/`, {
                method: 'PUT',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${token}`
                },
                body: JSON.stringify(userData)
            });

            const data = await response.json();
            // console.log("Réponse du backend :", data); // Debug

            if (response.ok) {

                setMessage('Profil mis à jour avec succès.');
                setMessageType('success');
                setShowMessage(true);
                setTimeout(() => {
                    setShowMessage(false);
                    navigate(`/Mon-Profil`);
                }, 3000);
            } else {
                setMessage(data.message || "Erreur lors de la mise à jour du profil.");
                setMessageType('danger');
                setShowMessage(true);
            }
        } catch (error) {
            console.error('Erreur lors de la mise à jour:', error);
            setMessage("Une erreur réseau est survenue.");
            setMessageType('danger');
            setShowMessage(true);
        }
    };


    const handleReset = () => {
        setUserData(initialUserData);
    };

    const [showPassword, setShowPassword] = useState({
        mdp: false,
        mdp1: false,
        mdp2: false,
    });

    const togglePasswordVisibility = (field) => {
        setShowPassword((prev) => ({
            ...prev,
            [field]: !prev[field],
        }));
    };

    const renderPasswordField = (label, name) => (
        <Col md={4}>
            <Form.Group className="mb-3" controlId={name}>
                <Form.Label>{label}</Form.Label>
                <div style={{ position: "relative" }}>
                    <Form.Control
                        type={showPassword[name] ? "text" : "password"}
                        name={name}
                        value={userData[name]}
                        onChange={handleChange}
                        className="custom-input"
                    />
                    <span
                        onClick={() => togglePasswordVisibility(name)}
                        style={{
                            position: "absolute",
                            right: "10px",
                            top: "50%",
                            transform: "translateY(-50%)",
                            cursor: "pointer",
                            color: "#6c757d",
                        }}
                    >
                        {showPassword[name] ? <FaEyeSlash /> : <FaEye />}
                    </span>
                </div>
            </Form.Group>
        </Col>
    );

    return (
        <div id="wrapper">
            <Sidebar user_id={user_id} />
            <div id="page-wrapper" className="gray-bg">
                <Navbar user_id={user_id} />
                <div className="row wrapper border-bottom white-bg page-heading">
                    <div className="col-lg-12">
                        <h2 className='d-flex align-items-center'><FaUser size={25} className='mr-2' />Mon profil</h2>
                        <small>Ici vous pouvez consulter ou modifier vos informations.</small>

                        <small id='hbreadcrumb' className='d-flex justify-content-end'>
                            <ol className="breadcrumb custom-breadcrumb">
                                <li className="breadcrumb-item custom-breadcrumb-item">
                                    {/* Utiliser Link de react-router-dom pour la navigation */}
                                    <Link to={`/Menu`}>Accueil</Link>
                                </li>
                                <li className="breadcrumb-item custom-breadcrumb-item">
                                    {/* Utiliser Link de react-router-dom pour la navigation */}
                                    Mon profil
                                </li>
                            </ol>
                        </small>
                    </div>
                </div>
                <div className="container wrapper wrapper-content animated fadeInRight mt-5">
                    <div className="row">
                        <div className="col-lg-2"></div>
                        <div className="col-lg-8">
                            {/* <h3>Informations d'identité</h3> */}
                            {showMessage && (
                                <Alert variant={messageType} onClose={() => setShowMessage(false)}>
                                    {message}
                                </Alert>
                            )}
                            <div className="hpanel mb-5">
                                <div className="panel-body styled-panel">
                                    <div className="mb-4 text-center">
                                        <i className="fa fa-user-circle login-logo" style={{ fontSize: '50px' }}></i>
                                    </div>
                                    <h3 className="font-bold text-center">Consultez votre profil</h3>
                                    <Form onSubmit={handleSubmit} className="reg-page">
                                        <Row>

                                            <Col md={6}>
                                                <Form.Group className="mb-3" controlId="nom">
                                                    <Form.Label>Nom</Form.Label>
                                                    <Form.Control
                                                        type="text"
                                                        name="nom"
                                                        value={userData.nom}
                                                        onChange={handleChange}
                                                        className="custom-input"
                                                    />
                                                </Form.Group>
                                            </Col>

                                            <Col md={6}>
                                                <Form.Group className="mb-3" controlId="prenoms">
                                                    <Form.Label>Prénoms</Form.Label>
                                                    <Form.Control
                                                        type="text"
                                                        name="prenoms"
                                                        value={userData.prenoms}
                                                        onChange={handleChange}
                                                        className="custom-input"
                                                    />
                                                </Form.Group>
                                            </Col>

                                            <Col md={6}>
                                                <Form.Group className="mb-3" controlId="email">
                                                    <Form.Label>Email</Form.Label>
                                                    <Form.Control
                                                        type="email"
                                                        name="email"
                                                        placeholder={userData.email}
                                                        readOnly
                                                        className="custom-input"
                                                    />
                                                </Form.Group>
                                            </Col>

                                            <Col md={6}>
                                                <Form.Group className="mb-3" controlId="tel">
                                                    <Form.Label>Téléphone</Form.Label>
                                                    <PhoneInput
                                                        name="tel"
                                                        value={userData.tel}
                                                        country="bj"
                                                        onChange={handlePhoneChange}
                                                        onKeyDown={(e) => {
                                                            const numericValue = userData.tel.replace(/\D/g, '');
                                                            if (numericValue.startsWith('229')) {
                                                                if (e.key === 'Backspace' || e.key === 'Delete') {
                                                                    if (numericValue.length <= 5) e.preventDefault();
                                                                }
                                                                else if (numericValue.length >= 13 &&
                                                                    !['ArrowLeft', 'ArrowRight', 'Tab'].includes(e.key)) {
                                                                    e.preventDefault();
                                                                }
                                                            }
                                                        }}
                                                        required
                                                        inputStyle={{
                                                            width: "100%",
                                                            height: "33px",
                                                            fontSize: "12px",
                                                            paddingLeft: "55px"
                                                        }}
                                                        containerStyle={{ width: "100%" }}
                                                        inputProps={{
                                                            name: "tel",
                                                            required: true,
                                                        }}
                                                        dropdownStyle={{
                                                            maxHeight: "135px",
                                                            overflowY: "auto",
                                                            zIndex: 1050,
                                                        }}
                                                        onCountryChange={(country) => {
                                                            if (country.dialCode === "229") {
                                                                const currentNumeric = userData.tel.replace(/\D/g, '');
                                                                if (!currentNumeric.startsWith("22901")) {
                                                                    setUserData(prev => ({
                                                                        ...prev,
                                                                        tel: '22901' + currentNumeric.replace(/^229/, '').slice(0, 8)
                                                                    }));
                                                                }
                                                            }
                                                        }}
                                                    />
                                                </Form.Group>
                                            </Col>

                                            <>
                                                {renderPasswordField("Ancien mot de passe", "mdp")}
                                                {renderPasswordField("Nouveau mot de passe", "mdp1")}
                                                {renderPasswordField("Confirmer le nouveau mot de passe", "mdp2")}
                                            </>
                                        </Row>

                                        <div className="text-center">
                                            <Button type="button" variant="default" onClick={handleReset}>
                                                <strong>Annuler</strong>

                                            </Button>
                                            <Button type="submit" variant="success" className="ml-2">
                                                <strong>Modifier</strong>

                                            </Button>
                                        </div>
                                    </Form>
                                </div>
                            </div>
                        </div>

                        <div className="col-lg-2"></div>
                    </div>
                </div>

                <div className="footer text-center">
                    {/* <div className="float-right">
                        10GB of <strong>250GB</strong> Free.
                    </div> */}
                    <div>
                        <strong><a href="https://www.adnservicespro.com/" target="_blank" rel="noopener noreferrer" style={{ color: "#3088C0" }}>ADN Services</a></strong> &copy; 2025. Tous droits réservés | Réalisé par <a href="https://inovact.com/" target="_blank" rel="noopener noreferrer" style={{ color: "#3088C0" }}>INOVACT SARL</a>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ProfilUtilisateur;
